import { Upload, ListVideo, Palette, Download } from "lucide-react";

const TABS = [
  ["upload", "Upload", Upload],
  ["captions", "Captions", ListVideo],
  ["style", "Style", Palette],
  ["export", "Export", Download],
];

export const NavBar = ({ tab, setTab, count }) => (
  <nav aria-label="Main sections"
    className="fixed bottom-0 inset-x-0 z-40 h-16 grid grid-cols-4 bg-[#14161c]/95 backdrop-blur-md border-t border-[var(--cc-border)] md:static md:h-14 md:border-t-0 md:border-b md:bg-[var(--cc-panel)]">
    {TABS.map(([id, label, Icon]) => {
      const active = tab === id;
      return (
        <button key={id} onClick={() => setTab(id)} data-testid={`nav-${id}`} aria-current={active ? "page" : undefined}
          className={`relative flex flex-col md:flex-row items-center justify-center gap-1 md:gap-2 text-[11px] md:text-sm font-semibold transition-colors ${active ? "text-[var(--cc-accent)]" : "text-[var(--cc-text-2)] hover:text-white"}`}>
          <Icon className="h-5 w-5" />
          <span>{label}{id === "captions" && count > 0 ? ` (${count})` : ""}</span>
          {active && <span className="absolute top-0 md:top-auto md:bottom-0 left-1/4 right-1/4 h-0.5 bg-[var(--cc-accent)] rounded" />}
        </button>
      );
    })}
  </nav>
);
